import * as React from "react";

function TowerBroadcastIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M160.9 59.01c-11.6-6.41-26.2-2.25-32.6 9.38C117.6 87.6 112 109.4 112 131.4c0 19.03 4.031 37.44 11.98 54.62 4.047 8.777 12.73 13.93 21.8 13.93a23.95 23.95 0 0 0 10.05-2.219C167.9 192.2 173.1 177.1 167.5 165.9c-5-10.8-7.5-22.4-7.5-34.5 0-13.93 3.547-27.69 10.25-39.81 6.45-11.55 2.25-26.17-9.35-32.58zM62.61 2.363C46.17-4.32 27.58 3.676 20.95 20.02 7.047 54.36 0 90.69 0 127.1c0 38.2 7.047 74.6 20.95 108.9 5.03 12.5 17.02 20 29.68 20 3.98 0 8.06-.7 11.98-2.3C79 247 86.91 228.4 80.27 212 69.47 185.3 64 157.1 64 128c0-29.06 5.469-57.3 16.27-83.99C86.91 27.64 79 8.988 62.61 2.363zM555 20.02c-6.609-16.41-25.23-24.31-41.66-17.66-16.39 6.625-24.3 25.28-17.66 41.65C506.5 70.7 512 98.95 512 128c0 29.06-5.469 57.31-16.27 83.1-6.63 17.3 1.27 35.9 17.67 42.6 3.9 1.6 8 2.3 12 2.3 12.66 0 24.64-7.562 29.67-20C568.1 201.7 576 165.3 576 127.1c0-36.41-7.9-72.74-21-107.08zM420.2 58.23c-12.03 5.562-17.28 19.81-11.72 31.84C413.5 100.9 416 112.5 416 124.6c0 13.94-3.547 27.69-10.25 39.81-6.422 11.59-2.219 26.22 9.375 32.62 3.688 2.031 7.672 3 11.61 3 8.438 0 16.64-4.47 21.02-12.37C458.4 168.4 464 146.6 464 124.6c0-19.03-4.031-37.43-11.98-54.62-5.52-12.09-19.92-17.28-31.82-11.75zm-118.4 7.22C260.5 56.78 224 88.13 224 128c0 23.63 12.95 44.04 32 55.12v296.9c0 17.67 14.33 32 32 32s32-14.33 32-32V183.1c23.25-13.54 37.42-40.96 30.03-71.18C344.4 88.91 325 70.31 301.8 65.45z"
  }));
}

const ForwardRef = React.forwardRef(TowerBroadcastIcon);
export default ForwardRef;